module.exports = __webpack_public_path__ + "media/assets/icon-pdf-24c06a7239a348fe7b2036b0e2dc75525802c3cecbc8e62bd884b5d6c723dfb3.png";